import Vuex from 'vuex';
import { createHelpers } from 'vuex-map-fields';

Vue.use(Vuex);
const { getFieldBuscador, updateFieldBuscador } = createHelpers({
  getterType: 'getFieldBuscador',
  mutationType: 'updateFieldBuscador',
});

export default {
  namespaced: true,
  state: {
    busqueda: '',
    solicitudes: [],
    iniciar_busqueda: false,
  },
  getters: {
    getFieldBuscador,
  },
  mutations: {
    updateFieldBuscador,
  },
};
